function Footer(){
    return <div className="bg-blue-900 text-center">
        <h2 className="text-white font-bold sm:text-[1.5vw] text-[3vw] p-10">© Acquire Pvt. Ltd.</h2>
    </div>
}

export default Footer;